import React from 'react'

interface IcUnflaggedProps extends React.SVGProps<SVGSVGElement> {
  width?: string
  height?: string
  color?: string
  style?: React.CSSProperties
}

const IcUnflagged: React.FC<IcUnflaggedProps> = ({
  width = '16px',
  height = '16px',
  color = '#6B7280',
  style,
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      color={color}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.3999 4.7999C2.3999 3.47442 3.47442 2.3999 4.7999 2.3999H12.7999C13.1029 2.3999 13.3799 2.5711 13.5154 2.84213C13.651 3.11316 13.6217 3.43749 13.4399 3.6799L11.3999 6.3999L13.4399 9.1199C13.6217 9.36232 13.651 9.68665 13.5154 9.95767C13.3799 10.2287 13.1029 10.3999 12.7999 10.3999H4.7999C4.35807 10.3999 3.9999 10.7581 3.9999 11.1999V13.5999C3.9999 14.0417 3.64173 14.3999 3.1999 14.3999C2.75807 14.3999 2.3999 14.0417 2.3999 13.5999V4.7999Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default IcUnflagged
